export default __webpack_public_path__ + "static/media/Equivalent Exchange.2ce8f9e1.png";